import { useRef, useState } from 'react';
import papaOurs from '../../images/papaOurs.webp';
import phone from '../../images/phone.png';
import mail from '../../images/mail.png';
function ContactForm() {
  const form = useRef(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    // Convert form to JSON
    const formData = new FormData(form.current);
    const JSONFormData = JSON.stringify(Object.fromEntries(formData));

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSONFormData,
      });

      alert(response.ok ? 'Message envoyé !' : 'Erreur lors de l\'envoi du message, veuillez réessayer.');
    }
    catch (error) {
      alert('Erreur lors de l\'envoi du message, veuillez réessayer.');
    }

    setSubmitting(false);
  }

  return (
    <div className="flex flex-col items-center w-full mb-40" id='contact-form-wrapper'>
      <div className="pt-12 max-w-7xl px-10 m6:px-5 w-full">
        <div className="bg-white flex flex-row rounded-xl shadow-2xl">
          <img src={papaOurs} alt="Papa ours" className="w-112 h-auto rounded-xl m10:hidden " />
          <form className="grid grid-cols-2 justify-end grid-rows-5 w-2/3 m10:w-full pl-10 m10:pl-0  m-4" onSubmit={submit} ref={form}>
            {/* <input type='text' className="text-xl px-10 py-6 m-4 col-span-1 m6:col-span-2 row-span-1 rounded-lg duration-500 border-2 shadow-lg focus:-translate-y-2 focus:bg-slate-100 hover:bg-slate-100" placeholder='Nom' name='lastName' required />
            <input type='text' className="text-xl px-10 py-6 m-4 col-span-1 m6:col-span-2 row-span-1 rounded-lg duration-500 border-2 shadow-lg focus:-translate-y-2 focus:bg-slate-100 hover:bg-slate-100" placeholder='Prénom' name='firstName' required /> */}
            <input type='email' placeholder='Votre adresse email' className="text-xl px-10 m8:px-4 py-6 m-2 col-span-2 row-span-1 rounded-lg duration-500 border-2 focus:-translate-y-2 focus:bg-slate-100 hover:bg-slate-100" name='email' required />
            {/* <input type='text' className="text-xl px-10 py-6 m-4 col-span-2 row-span-1 rounded-lg duration-500 border-2 shadow-lg focus:-translate-y-2 focus:bg-slate-100 hover:bg-slate-100" placeholder='Sujet' name='subject' required /> */}
            <textarea placeholder='Votre message' className="text-xl px-10 m8:px-4 py-6 m-2 col-span-2 row-span-3 rounded-lg duration-500 border-2 focus:-translate-y-2 focus:bg-slate-100 hover:bg-slate-100" name='message' required></textarea>
            <div className="col-span-2 row-span-1 flex justify-center">
              <input type='submit' className="w-1/2 m8:w-full text-3xl text-white py-6 m-2 rounded-lg duration-500 border-2 focus:translate-x-2 hover:translate-x-2 bg-secondary focus:opacity-60 hover:opacity-60 cursor-pointer" value={submitting ? 'Envoi...' : 'Envoyer →'} disabled={submitting} />
            </div>
          </form>
        </div>
        <div className="flex flex-row justify-center gap-40 mt-10 text-2xl m6:text-xl m8:flex-col m8:items-center m8:gap-8" id="contact-datas">
          <div className="flex flex-row items-center gap-4">
            <img src={mail} alt="Mail" className="w-10" />
            <span>contact@snowgmao.fr</span>
          </div>
          <div className="flex flex-row items-center gap-4">
            <img src={phone} alt="Phone" className="w-10" />
            <span>+33 6 43 45 13 97</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
